import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
import { mockedPlot } from './plots';
import { mockedStation } from './stations';
const arrayOfPlotAndStation = [mockedPlot, mockedStation];
const mockedMyFarmPaginatedResponse = mockedPaginatedResponse(arrayOfPlotAndStation);
const mock = {
    getMany: mockedRequester(mockedMyFarmPaginatedResponse, 'myFarm.getMany'),
    getPage: mockedRequester(mockedMyFarmPaginatedResponse, 'myFarm.getPage'),
    getAllPages: mockedRequester(arrayOfPlotAndStation, 'myFarm.getAllPages')
};
export default mock;
